import { ICanvasBannerPlaceholderFormat } from "./CanvasBannerPlaceholderFormat";
import { IFormatVersion } from "./FormatVersion";

export interface ICanvasBannerPlaceholder {
    id?: string;
    tag: string;
    description: string;
    formatVersionId?: string;
    formatVersion?: IFormatVersion;
    canvasBannerPlaceholderFormats?: ICanvasBannerPlaceholderFormat[];
}

export class CanvasBannerPlaceholder implements ICanvasBannerPlaceholder {
    id?: string;
    tag: string;
    description: string;
    formatVersionId?: string;
    formatVersion?: IFormatVersion;
    canvasBannerPlaceholderFormats?: ICanvasBannerPlaceholderFormat[];


    constructor();
    constructor(obj: ICanvasBannerPlaceholder);
    constructor(obj?: ICanvasBannerPlaceholder)
    {
        this.id = obj?.id || undefined;
        this.tag = obj?.tag || undefined;
        this.description = obj?.description || undefined;
        this.formatVersionId = obj?.formatVersionId || undefined;
        this.formatVersion = obj?.formatVersion || undefined;
        this.canvasBannerPlaceholderFormats = obj?.canvasBannerPlaceholderFormats || undefined;
	}
}
